import React from 'react'
import About from './About'
import Header from '../Header & Navbar/Header'
import Navbar from '../Header & Navbar/Navbar'

const MainAbout = () => {
  return (
    <>
    <Header />
    <About />
    <Navbar />
    </>
  )
}

export default MainAbout